
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7MaHq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $8Ksv7 = parcelRequire("8Ksv7");


var $jCoeB = parcelRequire("jCoeB");

const $5591b718940edee5$export$d92a178c6c95211f = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, spaceKey: spaceKey, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, Renderer: Renderer, getExtensionHandlers: getExtensionHandlers } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== extensionKey || $[2] !== mode || $[3] !== node || $[4] !== spaceKey) {
        t1 = (RendererWrapper)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Ksv7.BlogPostsMacroHandler), {
                macroDefaultProps: {
                    contentId: contentId,
                    extensionKey: extensionKey,
                    mode: mode,
                    node: node,
                    spaceKey: spaceKey
                },
                macroParams: node?.parameters?.macroParams,
                RendererWrapper: RendererWrapper
            });
        $[0] = contentId;
        $[1] = extensionKey;
        $[2] = mode;
        $[3] = node;
        $[4] = spaceKey;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== Renderer || $[7] !== appearance || $[8] !== getExtensionHandlers || $[9] !== showTemplateInputInPreview || $[10] !== showTemplateVariablesInPreview || $[11] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jCoeB.NestedAdfSSRRendererWrapperProvider), {
            appearance: appearance,
            Renderer: Renderer,
            getExtensionHandlers: getExtensionHandlers,
            showTemplateInputInPreview: showTemplateInputInPreview,
            showTemplateVariablesInPreview: showTemplateVariablesInPreview
        }, t1);
        $[6] = Renderer;
        $[7] = appearance;
        $[8] = getExtensionHandlers;
        $[9] = showTemplateInputInPreview;
        $[10] = showTemplateVariablesInPreview;
        $[11] = t1;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
};
module.exports["BlogPostsSSRExtensionHandler"] = $5591b718940edee5$export$d92a178c6c95211f;

});

parcelRegister("8Ksv7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $11414ac1857ca883$export$cfa4ed6e2f4ad26 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lJE6O",
    name: "BlogPostsMacroHandler",
    loader: async ()=>(await (parcelRequire("75gzZ"))).BlogPostsMacroRenderer
});
module.exports["BlogPostsMacroHandler"] = $11414ac1857ca883$export$cfa4ed6e2f4ad26;

});

parcelRegister("75gzZ", function(module, exports) {

let $5285dc5bdbee9624$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5285dc5bdbee9624$var$load("30b92"),
    $5285dc5bdbee9624$var$load("f0CsL"),
    $5285dc5bdbee9624$var$load("56OxX"),
    $5285dc5bdbee9624$var$load("1GCFv"),
    $5285dc5bdbee9624$var$load("bV5bW"),
    $5285dc5bdbee9624$var$load("28h7Y")
]).then(()=>parcelRequire('5iRsI'));

});

parcelRegister("ZJvdP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $543e3a9ad9cfc398$export$3ad73c971369d052 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sYDyD",
    name: "PageIncludeMacroHandler",
    loader: async ()=>(await (parcelRequire("gIDv4"))).PageIncludeMacroRenderer
});
module.exports["PageIncludeMacroHandler"] = $543e3a9ad9cfc398$export$3ad73c971369d052;

});

parcelRegister("gIDv4", function(module, exports) {

let $c2bf65516d0474fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2bf65516d0474fe$var$load("5h4De").then(()=>parcelRequire('doY9Y'));

});

parcelRegister("e1Stz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36f7db2a9cac59c0$export$7cf7439e5d7797c5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ymRP0",
    name: "PagePropertiesReportRenderer",
    loader: async ()=>(await (parcelRequire("laZTo"))).PagePropertiesReportRenderer
});
module.exports["PagePropertiesReportRenderer"] = $36f7db2a9cac59c0$export$7cf7439e5d7797c5;

});

parcelRegister("laZTo", function(module, exports) {

let $f6aa8aaf8c17215c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f6aa8aaf8c17215c$var$load("efUj2"),
    $f6aa8aaf8c17215c$var$load("7BHAC"),
    $f6aa8aaf8c17215c$var$load("N3TvS"),
    $f6aa8aaf8c17215c$var$load("6wr18"),
    $f6aa8aaf8c17215c$var$load("hhss7"),
    $f6aa8aaf8c17215c$var$load("ffEVr"),
    $f6aa8aaf8c17215c$var$load("dnwTC")
]).then(()=>parcelRequire('3Jp28'));

});


//# sourceMappingURL=BlogPostsSSRExtensionHandler.571feb46.js.map
